import {messages} from '@smartmixin/i18n';
import {
  Broadcast,
  CreditCard,
  Link as LinkIcon,
  Question,
  RocketLaunch,
  UserCircle,
} from '@phosphor-icons/react';
import {MessageDescriptor} from 'react-intl';

export const CATEGORY_ORDER = [
  'getting-started',
  'account',
  'stations',
  'providers',
  'billing',
  'troubleshooting',
];

export const CATEGORY_MESSAGES: Record<string, MessageDescriptor> = {
  'getting-started': messages.common.helpCategoryGettingStarted,
  account: messages.common.helpCategoryAccount,
  stations: messages.common.helpCategoryStations,
  providers: messages.common.helpCategoryProviders,
  billing: messages.common.helpCategoryBilling,
  troubleshooting: messages.common.helpCategoryTroubleshooting,
};

export const CATEGORY_ICONS: Record<string, React.ElementType> = {
  'getting-started': RocketLaunch,
  account: UserCircle,
  stations: Broadcast,
  providers: LinkIcon,
  billing: CreditCard,
  troubleshooting: Question,
};

export const CATEGORY_COLORS: Record<string, string> = {
  'getting-started': '#4CAF50',
  account: '#2196F3',
  stations: '#9C27B0',
  providers: '#FF9800',
  billing: '#E91E63',
  troubleshooting: '#607D8B',
};

// Curated top support drivers shown on the help center landing page.
// Revisit against support-inbox stats when the mix of questions shifts.
export const POPULAR_ARTICLE_SLUGS = [
  'getting-started',
  'connecting-station',
  'troubleshooting-common-issues',
  'managing-subscription',
];

export const SUPPORT_EMAIL = 'contact@smartmixin.io';

// Stable id so the Cmd/Ctrl+K shortcut can focus whichever search input is
// on the current help page.
export const HELP_SEARCH_INPUT_ID = 'help-center-search-input';

// Estimate reading time based on word count
export const getReadingTime = (content: string): number => {
  const wordsPerMinute = 200;
  const wordCount = content.split(/\s+/).length;
  return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
};
